import SquareCross from './SquareCross'

export default SquareCross
